module.exports = __webpack_public_path__ + "img/logo-clearmortgagecapital.ca347f6f.svg";